// Destinations accepted by generic notifications and offered by the Admin.
// Keep platform-specific navigation helpers in the frontend.
export const AppRoutes = {
  invite: '/invite',
  // Main tabs
  home: '/',
  suggestions: '/suggestions',
  cards: '/cards',
  chat: '/chat',
  profile: '/profile',

  // Settings tabs (standalone settings screen)
  settingsPartnerTab: '/settings?tab=partner',
  settingsAccountTab: '/settings?tab=account',
  settingsPreferencesTab: '/settings?tab=preferences',

  // Settings with subscription modal open
  settingsSubscriptionModal: '/settings?tab=account&openSubscription=true',

  // Other routes
  notifications: '/notifications',
  settings: '/settings',
  badges: '/badges',
  dates: '/dates',
  responsesHistory: '/responses-history',
  manualSuggestions: '/manual-suggestions',
  suggestionHistory: '/suggestion-history',
  chatHistory: '/chat/history',
  moments: '/moments',
  horoscope: '/horoscope',
  questionHistory: '/question-history',
  questionHistoryWithModal: '/question-history?returnTo=/(tabs)/profile&openModal=true',
  together: '/together',
  ourMemories: '/our-memories',
  photoExports: '/photo-exports',
  heartBank: '/heart-bank',
  movieNight: '/movie-night',
  movieNightMatches: '/movie-night?tab=matches',
  movieNightSettings: '/movie-night/settings',
  sharedChat: '/chat/shared',
} as const;
